import { ComparisonPageTemplate } from '@/components/ComparisonPageTemplate'
import { getCompetitor } from '@/data/compare'

export default function SubmittableComparePage() {
  return <ComparisonPageTemplate competitor={getCompetitor('submittable')} />
}
